import { months } from 'constants/date';
import moment from 'moment';

import {
    SET_CLINICAL_MASTITIS_DATA,
    SET_CLINICAL_MASTITIS_FILTER_OPTIONS,
    SET_CLINICAL_MASTITIS_FILTERS,
    SET_CLINICAL_MASTITIS_DATA_LOADING,
    RESET_CLINICAL_MASTITIS_FILTERS,
    SET_CLINICAL_MASTITIS_PROPERTY_ID
} from '@/redux/mutations';

export const initialState = {
    property_id: null,
    data: {},
    loading: false,
    optionsFilters: {
        years: [moment().year()],
        months: months,
        sectors: ['Todos'],
        races: ['Todos']
    },
    selectedFilters: {
        sectors: ['Todos'],
        races: ['Todos'],
        years: [moment().year()],
        months: months
    }
};

const indicatorsPanelClinicalMastitisReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case SET_CLINICAL_MASTITIS_PROPERTY_ID:
            return {
                ...state,
                property_id: actions.payload
            };
        case SET_CLINICAL_MASTITIS_DATA:
            return {
                ...state,
                data: actions.payload
            };
        case SET_CLINICAL_MASTITIS_DATA_LOADING:
            return {
                ...state,
                loading: actions.payload
            };
        case SET_CLINICAL_MASTITIS_FILTER_OPTIONS:
            return {
                ...state,
                optionsFilters: actions.payload
            };
        case SET_CLINICAL_MASTITIS_FILTERS:
            return {
                ...state,
                selectedFilters: actions.payload
            };
        case RESET_CLINICAL_MASTITIS_FILTERS:
            return {
                ...state,
                selectedFilters: {
                    sectors: ['Todos'],
                    races: ['Todos'],
                    years: [moment().year()],
                    months: months
                }
            };
        default:
            return state;
    }
};

export default indicatorsPanelClinicalMastitisReducer;
